import axios from "axios";
import getCsrfToken from "common/utils/getCsrfToken";
export async function changePaymentDayData(url, preferred_payment_day) {
  const res = await axios.post(
    url,
    {
      preferred_payment_day,
    },
    {
      headers: {
        "X-CSRF-Token": getCsrfToken(),
        "Content-Type": "application/json; charset=utf-8",
        Accept: "application/json; charset=utf-8",
      },
    }
  );
  return res.data;
}
